import React, { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_ALT_NAME = 'BioQuest';

const PoweredByBranding = ({
  className = '',
  labelClassName = '',
  textClassName = '',
  logoClassName = '',
  linkClassName = '',
  href = 'https://www.bioquestglobal.com/',
}) => {
  const [branding, setBranding] = useState({ logoUrl: null, altName: DEFAULT_ALT_NAME });

  useEffect(() => {
    let isMounted = true;

    const fetchBranding = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/cms/powered-by`);
        if (!response.ok) return;
        const data = await response.json();
        if (!isMounted) return;
        let logoUrl = data.powered_by_logo || null;
        if (logoUrl && logoUrl.startsWith('/api/')) {
          logoUrl = `${BACKEND_URL}${logoUrl}`;
        }
        setBranding({
          logoUrl,
          altName: data.powered_by_alt_name || DEFAULT_ALT_NAME,
        });
      } catch (error) {
        console.error('Failed to fetch powered by branding:', error);
      }
    };

    fetchBranding();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <span className={`inline-flex items-center justify-center gap-1 min-w-0 ${className}`.trim()}>
      <span className={labelClassName}>Powered by</span>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center min-w-0 ${linkClassName}`.trim()}
      >
        {branding.logoUrl ? (
          <img
            src={branding.logoUrl}
            alt={branding.altName || DEFAULT_ALT_NAME}
            className={`block object-contain max-w-full ${logoClassName}`.trim()}
            loading="lazy"
          />
        ) : (
          <span className={`truncate ${textClassName}`.trim()}>{branding.altName || DEFAULT_ALT_NAME}</span>
        )}
      </a>
    </span>
  );
};

export default PoweredByBranding;
